import { Dtos, type SuretyAccountId, type SuretyBondId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { recentlyUsedSfaaCodesForAccountQueryKey } from "../../sfaa-code/sfaa-code.keys";
import { bondQueryKey } from "../bond.keys";

export const useAdminUpdateBond = (bondId: SuretyBondId, accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { put } = useRequest();

	const mutation = useMutation({
		mutationKey: ["updateAdminBond", bondId],
		mutationFn: async (data: Dtos.Admin.SuretyBond.Update.Request) => {
			await put(`/v2/admin/surety/bonds/${bondId}`, data, "none");
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: bondQueryKey(bondId) });
			queryClient.invalidateQueries({
				queryKey: recentlyUsedSfaaCodesForAccountQueryKey(accountId),
			});
		},
	});

	return {
		updateBond: mutation.mutate,
		updateBondIsLoading: mutation.isPending,
	};
};
